import { useApp } from "@/context/AppContext";
import { IMAGES } from "@/data/site";
import { PageHero, SectionHeader } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { Section } from "@/components/Section";
import { Leaf, Zap, Users, Droplets, TreePine, HeartHandshake } from "lucide-react";

const IMPACT_ICONS = [Zap, TreePine, Droplets, Users];
const INIT_ICONS = [Leaf, HeartHandshake, Users];

export default function ESG() {
  const { t } = useApp();
  const e = t.esgP;
  return (
    <div>
      <PageHero image={IMAGES.solarField} eyebrow={e.eyebrow} title={e.title} subtitle={e.sub}>
      </PageHero>

      <Section sid="esg.footprint" name="Impact Footprint" className="border-b border-teal-900/40 bg-[#E9F5F4]/40 oj-section">
        <div className="oj-container">
          <SectionHeader eyebrow={e.measured} title={e.footprint} />
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
            {e.impact.map(([value, label], i) => {
              const Icon = IMPACT_ICONS[i];
              return (
                <Reveal key={label} delay={i * 0.07}>
                  <div className="oj-card p-7 text-center h-full">
                    <div className="grid place-items-center w-12 h-12 rounded-xl bg-teal-500/15 border border-teal-400/30 mx-auto mb-4"><Icon className="w-6 h-6 text-teal-400" /></div>
                    <div className="text-2xl sm:text-3xl font-extrabold gold-text font-mono">{value}</div>
                    <div className="mt-1 text-xs text-slate-600">{label}</div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </Section>

      <Section sid="esg.csr" name="CSR Initiatives" className="oj-section">
        <div className="oj-container">
          <SectionHeader eyebrow={e.csr} title={e.devTitle} />
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {e.initiatives.map(([title, desc], i) => {
              const Icon = INIT_ICONS[i];
              return (
                <Reveal key={title} delay={i * 0.1}>
                  <div className="oj-card p-7 h-full">
                    <div className="grid place-items-center w-12 h-12 rounded-xl bg-amber-500/15 border border-amber-400/30 mb-4"><Icon className="w-6 h-6 text-amber-400" /></div>
                    <h4 className="font-bold text-white mb-2">{title}</h4>
                    <p className="text-sm text-slate-600 leading-relaxed">{desc}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </Section>
    </div>
  );
}
